import { useStore } from "@nanostores/preact"
import { profile, promo, support } from "../services/store"
import { useTranslation } from "./Translation"
import { PriceDisplay } from "./PriceDisplay"
import { annualSavingsAmounts } from "../services/promo"

import css from "../style.module.scss"
import checkIcon from "../static/icon-check--white.svg"

export const OfferNote = function OfferNote() {
  const t = useTranslation()
  const supportData = useStore(support)
  const user = useStore(profile)
  const promoState = useStore(promo)

  // Check if support data exists before accessing properties
  if (!supportData) {
    return null // or return a loading state
  }

  const { currencies, products, iso_countries: isoCountries } = supportData

  // Get user's country and currency
  const country = isoCountries.find((c) => c.iso === user.countryIso)
  const currency = currencies.find((c) => c.acronym === country.currency)

  const saveAmount = annualSavingsAmounts(products, currency.acronym, promoState.validation)

  return (
    <>
      {user.subscription === "annually" && (
        <p className={css["signup-note"]}>
          <img src={checkIcon} alt="checkmark" width={14} />
          {t("you_are_saving") || "You're saving"}{" "}
          <PriceDisplay
            originalAmount={saveAmount.original}
            discountedAmount={saveAmount.discounted}
            currency={currency}
            originalClassName={css["note-original-price"]}
            discountedClassName={css["note-current-price"]}
          />{" "}
          {t("per_year_words") || "per year"}
        </p>
      )}
      {user.subscription === "monthly" && (
        <p className={css["signup-note"]}>
          <img src={checkIcon} alt="checkmark" width={14} />
          {t("flexible_payments")}
        </p>
      )}
      <p className={css["signup-note"]}>
        <img src={checkIcon} alt="checkmark" width={14} />
        {t("easily_cancel_anytime")}
      </p>
    </>
  )
}
